define('model/CancelBookingReasonModel',['require','lib/model/BaseModel','lib/validator/ValidatorEmail','lib/validator/ValidatorStringLengthGreaterThan','lib/validator/ValidatorNotEmpty','Config'],function (require) {

	var BaseModel = require('lib/model/BaseModel');
	var ValidatorEmail = require('lib/validator/ValidatorEmail');
	var ValidatorStringLengthGreaterThan = require('lib/validator/ValidatorStringLengthGreaterThan');
	var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
	var Config = require('Config');

	/**
	 * Single booking data model
	 * 
	 * @class BookingModel
	 */
	return BaseModel.extend({
		
		url: '/booking-cancel/',
		
		defaults: {
			id: null,
			reason : '',
		},
		
		initialize: function () {
			this.validators = {
				//client_name: [new ValidatorNotEmpty()],
				reason : [new ValidatorStringLengthGreaterThan({
                    error: 'The cancellation reason is too short.',
                    value: 5
				})]
			};

			var config = Config.getInstance();
			if (config.getPluginStatus('cancelation_policy')) {
                if (parseInt(config.getOption('cancelation_policy_is_reason_required'))) {
                    this.validators.reason.push(new ValidatorNotEmpty());
                }
            }
			BaseModel.prototype.initialize.call(this);
		},

	});
	
});
